import { Box, Button, List, ListItem, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../../../styles/components/messageContentModal.module.scss";
import ModalWrapper from "../../../../ui/ModalWrapper/ModalWrapper";
import { getCurrentUTCDateTime } from "../../../../lib/functions/utils.lib";
import assest from "../../../../json/assest";
import { Stack } from "@mui/system";

const MessagePartnerModal = ({ open, onClose, handleUpdate, data }) => {
  // const handleCloseFilterModal = useCallback(() => {
  //   setOpen(false);
  // }, []);

  const [note, setNote] = useState("");
  // console.warn("note", note);

  const [attachments, setAttachments] = useState([]);
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setAttachments((curr) => [...curr, file]);
    }
  };

  const removeFile = (file_index) => {
    setAttachments((curr) => curr.filter((_, index) => file_index !== index));
  };

  const [utcDateTime, setUtcDateTime] = useState(getCurrentUTCDateTime());

  // console.warn("data", data);

  const handleSendMessage = () => {
    //
  };

  useEffect(() => {
    const timerId = setInterval(() => {
      setUtcDateTime(getCurrentUTCDateTime());
    }, 5000);

    // Clear the timer when the component unmounts
    return () => clearInterval(timerId);
  }, []);
  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      handleClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="rejectedModal"
    >
      <Box className={styles.messageModal}>
        <Box className={styles.messageModalHeader}>
          <h4>Message Partner</h4>
          <p>
            <span>Date:</span> {utcDateTime}
          </p>
        </Box>

        <Box className={styles.messageModalBody}>
          <Box className={styles.messageInput}>
            <label>
              Is there something you would like to ask the partner about?
            </label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
            ></textarea>
          </Box>
          <Box className="attachFileinput attachFileinputMessage">
            <input type="file" id="upload" onChange={handleFileChange} hidden />
            <label htmlFor="upload">
              <img src={assest.attachIcon} width={13} height={15} alt="" />{" "}
              Attach a file
            </label>
          </Box>
          <Stack direction="row" className={styles.filesName}>
            <List className={styles.fileLists}>
              {attachments?.length
                ? attachments.map((item, index) => {
                    return (
                      <ListItem key={index}>
                        <span className={styles.btnStyledFile}>
                          <img
                            src={assest.IconTrash}
                            width={16}
                            height={16}
                            alt="icon"
                          />
                          <Typography variant="overline">
                            {item?.name ? item.name : "N/A"}
                          </Typography>
                        </span>
                        <Button
                          className={styles.btnClose}
                          onClick={() => removeFile(index)}
                        >
                          <img
                            src={assest.IconcrossRound}
                            width={20}
                            height={20}
                            alt="icon"
                          />
                        </Button>
                      </ListItem>
                    );
                  })
                : ""}
              {attachments?.length ? (
                <ListItem>
                  <Box className={styles.addFiles}>
                    <input
                      type="file"
                      id="upload"
                      onChange={handleFileChange}
                      hidden
                    />
                    <label htmlFor="upload">
                      <img
                        src={assest.IconAddfile}
                        width={23.29}
                        height={23.29}
                        alt=""
                      />
                    </label>
                  </Box>
                </ListItem>
              ) : (
                ""
              )}
            </List>
          </Stack>
        </Box>

        <Box className={styles.messageModalFooter}>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSendMessage} className={styles.active}>
            Send Now
          </Button>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default MessagePartnerModal;
